import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Breakpoint } from '@mui/material';
import { Button } from './button';

export function CustomDialog({
  open,
  setOpen,
  dialogTitle,
  children,
  showOnlyAccept = false,
  actionText,
  disableAccept = false,
  showActions = true,
  onSubmit,
  onCancel,
  maxWidth = 'md',
  headerClass,
}: {
  open: boolean;
  setOpen: (x: boolean) => void;
  dialogTitle: string;
  children: JSX.Element | JSX.Element[];
  showOnlyAccept?: boolean;
  actionText?: {
    submit?: string;
    cancel?: string;
  };
  disableAccept?: boolean;
  showActions?: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
  maxWidth?: false | Breakpoint | undefined;
  headerClass?: string;
}) {
  const handleOnCancel = () => {
    onCancel && onCancel();
    setOpen(false);
  };

  const handleOnSubmit = () => {
    onSubmit && onSubmit();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleOnCancel}
      fullWidth={true}
      maxWidth={maxWidth}>
      <div
        className={headerClass}
        style={{
          borderBottom: '1px solid rgba(0,0,0,.05)',
          paddingTop: '8px',
          paddingRight: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <DialogTitle
          className="header-title"
          style={{
            fontSize: '18px',
            fontWeight: 500,
            color: 'rgba(255, 255, 255, 1)',
          }}>
          {dialogTitle}
        </DialogTitle>
        <IconButton
          className="close-icon"
          aria-label="close"
          onClick={handleOnCancel}
          sx={{
            color: 'white',
          }}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent>{children}</DialogContent>
      {showActions && (
        <DialogActions className="mb-2 mr-3">
          {!showOnlyAccept && (
            <Button
              className="mr-2"
              onClick={handleOnCancel}
              variant="button--secondary">
              <span>{actionText?.cancel}</span>
            </Button>
          )}
          <Button
            onClick={handleOnSubmit}
            variant="button--primary"
            disabled={disableAccept}>
            <span>{actionText?.submit}</span>
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
